/**
 * Cache für Hub-Daten (Gebäude + Flotte) pro Planet.
 * Wird beim Boot für eigene Planeten gefüllt, damit der Hub ohne Lade-Anzeige öffnet.
 */
import type { BuildingType } from '../config/BuildingTypes';
import { parseShipsFromResponse } from '../network/FleetDataService';

export interface BuildingsCache {
  levels: Map<BuildingType, number>;
  timers: Map<BuildingType, string>;
}

export interface FleetCache {
  composition: number[];
  levels: Map<BuildingType, number>;
}

export interface PlanetHubCache {
  buildings: BuildingsCache;
  fleet: FleetCache;
}

/** Parst tick-planet Response in Hub-Cache-Format. */
export function updateHubCache(
  cache: Map<string, PlanetHubCache>,
  planetId: string,
  key: 'buildings' | 'fleet',
  data: PlanetHubCache['buildings'] | PlanetHubCache['fleet'],
): void {
  const cur = cache.get(planetId) ?? {
    buildings: { levels: new Map(), timers: new Map() },
    fleet: { composition: [0, 0, 0, 0, 0, 0, 0, 0], levels: new Map() },
  };
  cache.set(planetId, key === 'buildings'
    ? { ...cur, buildings: data as PlanetHubCache['buildings'] }
    : { ...cur, fleet: data as PlanetHubCache['fleet'] });
}

export function parseTickPlanetToCache(data: {
  buildings?: { type: string; level: number; upgrading_until?: string }[];
  ships?: Record<string, number>;
}): PlanetHubCache {
  const levels = new Map<BuildingType, number>();
  const timers = new Map<BuildingType, string>();
  if (data?.buildings) {
    for (const b of data.buildings) {
      levels.set(b.type as BuildingType, b.level);
      if (b.upgrading_until) timers.set(b.type as BuildingType, b.upgrading_until);
    }
  }
  const fleetLevels = new Map<BuildingType, number>();
  if (data?.buildings) {
    for (const b of data.buildings) {
      fleetLevels.set(b.type as BuildingType, b.level);
    }
  }
  return {
    buildings: { levels, timers },
    fleet: {
      composition: parseShipsFromResponse(data?.ships ?? null),
      levels: fleetLevels,
    },
  };
}
